<template>


	<div id="app-boards">


		<!-- 목록 -->
		<div class="container">

			<!-- 작성 -->
			<div id="app-boards-frm" v-if="params.mode === 'form'">
				<form-default></form-default>
			</div>
			<!-- 작성 -->


			<!-- 상세본문 -->
			<div id="app-boards-view" v-if="params.mode !== 'form'">
				<detail-default v-show="params.idx > 0 && params.idx !== undefined" :boardInfoVO="boardInfoVO" :boardVO="boardVO" @goForm="goForms" @goList="goList"></detail-default>
			</div>
			<!-- 상세본문 -->

			<div class="content board-list" v-if="params.mode === 'list'">

				<!-- 페이지 타이틀 -->
				<h2 class="tit_page">{{ boardInfoVO.boardName }}</h2>


				<!-- 카테고리 -->
				<form @submit.prevent="doSearch">

					<code-selector field="cateCode" :code="boardInfoVO.cateCode" @selectCode="setCateCode"></code-selector>


					<!-- 검색 -->
					<div class="board_search">

						<div class="select_box" v-if="boardInfoVO.isStatus === true">
							<select name="status-select-box" class="slt" v-model="params.statusCode">
								<option value="">전체</option>
								<option v-for="(item, index) in boardInfoVO.statusList" :value="item.code">{{ item.codeName }}</option>
							</select>
						</div>

						<div class="input_box">
							<input type="text" name="" class="inp" placeholder="내용을 입력해 주세요." v-model="params.searchText">
							<button type="submit">
								<img src="/ssflex_cs1/assets/img/common/ico/ico_search.svg" alt="검색">
							</button>
						</div>
					</div>
					<div class="board_sort">
						<div class="total_box">총 <b>{{ boardCount }}</b>건</div>

						<board-sorter @doSort="doSort"></board-sorter>

					</div>
				</form>


				<!-- 리스트 -->
				<list-webzine v-if="boardInfoVO.boardMode === 'webzine'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-webzine>
				<list-basic v-else-if="boardInfoVO.boardMode === 'basic'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-basic>
				<list-gallery v-else-if="boardInfoVO.boardMode === 'gallery'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-gallery>
				<list-faq v-else-if="boardInfoVO.boardMode === 'faq'" :board-info="boardInfoVO" :notice-list="noticeList" :board-list="boardList" @goBoardOne="goView"></list-faq>
				<list-classic v-else :notice-list="noticeList" :board-info="boardInfoVO" :board-list="boardList" @goBoardOne="goView"></list-classic>


				<!-- 버튼 -->
				<div class="board_btn right" v-if="isLogin() && boardInfoVO.isWrite">
					<button type="button" class="btn btn-dark" @click="goForms">등록</button>
				</div>
				<div class="board_more" v-if="boardList.length < boardCount">
					<button type="button" class="btn_more" @click="doLoadMore()"><img src="/ssflex_cs1/assets/img/common/ico/ico_down_w.svg" alt=""></button>
				</div>

			</div>
		</div>

	</div>


</template>

<script>
import $ from "jquery";

import ListClassic from "@/cs1/components/boards/lists/listClassic";
import DetailDefault from "@/cs1/components/boards/details/detailDefault";
import ListWebzine from "@/cs1/components/boards/lists/listWebzine";
import ListGallery from "@/cs1/components/boards/lists/listGallery";
import ListFaq from "@/cs1/components/boards/lists/listFaq";
import ListBasic from "@/cs1/components/boards/lists/listBasic";
import FormDefault from "@/cs1/components/boards/forms/formDefault";
import Swiper from "@/../public/ssflex_cs1/assets/js/swiper.min";
import BoardSorter from "@/cs1/components/boards/boardSorter";
import CodeSelector from "@/cs1/components/selectors/codeSelector";


export default {
	name: "appBoards",
	components: {CodeSelector, BoardSorter, FormDefault, ListBasic, ListFaq, ListGallery, ListWebzine, DetailDefault, ListClassic},
	props: {
		boardKey: String,
	},
	data() {

		let defBoardKey = this.boardKey
		if (defBoardKey == null) {
			defBoardKey = this.$route.params.boardKey
		}

		var params = this.pageUtils.Params()
		params.cateCode = this.webUtils.getParameter("cateCode");
		if (this.webUtils.getParameterInt("idx") > 0) {
			params.idx = this.webUtils.getParameterInt("idx");
		}

		if (!this.stringUtils.isEmpty(this.$route.query.writerKey)) {
			params.writerKey = this.$route.query.writerKey
		}

		return {

			params,

			defBoardKey,
			boardVO: {},

			boardCount: 0,
			boardInfoVO: {},
			noticeList: [],
			boardList: [],
			statusCode: "",

		}
	},
	beforeCreate() {
	},
	async created() {
		this.boardInfoVO = await this.getBoardInfo(this.defBoardKey);
		this.params.size = this.boardInfoVO.pageCount
	},
	mounted() {
		if (location.hash) {
			let hash = location.hash.replace("#", "")
			if (hash !== 'loadMore') {
				this.webUtils.scroll(this, '#item-' + hash)
			}
		}

		if (this.mode !== "form" && this.params.idx > 0) {
			this.getBoardOne();
		}
		this.getBoardList();

	},
	updated() {
		/**
		 * common-ui.js 공통 부분 적용
		 * 카테고리 메뉴
		 */
		this.$nextTick(() => {
			// 서브 페이지 탭
			var swiper = new Swiper(".board_category", {
				slidesPerView: "auto",
				spaceBetween: 24,
				freeMode: true,
				breakpoints: {
					767: {
						spaceBetween: 16,
					},
				},
			});

		})
	},
	methods: {

		getBoardList() {

			this.$eventBus.$emit("startProgress")

			// this.params.mode = "list";
			var temp = JSON.parse(JSON.stringify(this.params))
			temp.boardKey = this.defBoardKey

			this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardList", temp, (res) => {
				var result = res.data
				if (result.status === "ok") {
					if (result.boardInfoVO.isNologin && !this.isLogin()) {
						this.requireLogin(this, false)
					}
					this.boardCount = result.boardMap.count
					//this.boardList.push(...result.boardMap.list)
					this.boardList = result.boardMap.list
					this.noticeList = result.noticeMap.list

					if (location.hash) {
						let hash = location.hash.replace("#", "")
						if (hash === 'loadMore') {
							this.webUtils.scroll(
								this
								, '#item-' + this.boardList[(this.params.size) * (this.params.page * 1) - 1].idx
								, {
									behavior: "smooth"
									, block: "center"
								}
								, () => this.webUtils.removeHash()
								, () => {
									document.querySelector('.board-list').scrollIntoView({
										behavior: "smooth"
										, block: "end"
									})
									this.webUtils.removeHash()
								}
								, 1000
							)
						}
					}
				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
				}
				this.$eventBus.$emit("doneProgress")
			})
		},

		/**/
		doLoadMore() {
			this.resetBoardOne();
			this.params.page++;
			this.params.hash = 'loadMore'
			this.webUtils.goTo(this, this.params)
			// this.pageUtils.routerPush(this, this.params)

			/*this.$router.push({
					  query: this.params,
				  }).catch(() => {})
				  this.getBoardList();*/
		},


		setCateCode(_cateCode) {

			this.resetBoardOne();
			this.boardList = []
			this.params.page = 0
			this.params.size = this.boardInfoVO.pageCount
			this.params.cateCode = _cateCode;
			this.params.searchText = "";
			this.params.statusCode = "";

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
				query: this.params,
			}).catch(() => {})
			this.getBoardList();*/
		},


		doSearch() {
			this.resetBoardOne();
			this.boardList = []
			this.params.page = 0
			this.params.size = this.boardInfoVO.pageCount

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
				query: this.params,
			}).catch(() => {})
			this.getBoardList();*/
		},

		doSort(_sort) {
			this.params.sort = _sort;
			this.pageUtils.routerPush(this, this.params)
			// this.getMainList();
		},


		getBoardOne() {

			this.$eventBus.$emit("startProgress", 1)
			this.axiosCaller.get(this, this.APIs.BOARDS + "/getBoardOne/" + this.params.idx, {}, (res) => {
				var result = res.data
				this.boardVO = result.boardVO
				this.$eventBus.$emit("doneProgress", 1)

				this.$nextTick(() => {
					this.webUtils.scrollTo("#app")
				})
			})
		},


		resetBoardOne() {
			delete this.params.idx
			this.boardVO = {}
		},


		goList() {

			var prevIdx = this.params.idx;
			this.params.mode = "list";
			this.params.hash = prevIdx

			this.resetBoardOne();

			this.webUtils.goTo(this, this.params)
		},


		goView(_idx) {

			if (parseInt(this.params.idx) === _idx) {
				location.reload()
			}

			// 기존 게시물 삭제
			this.resetBoardOne();
			this.params.idx = _idx
			this.params.boardKey = this.defBoardKey

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
				query: this.params,
			}).catch(() => {})
			this.getBoardOne();*/
		},


		goForms(e, _idx = null) {

			/*var queryStr = "?mode=form"
			if ( _idx !== undefined && _idx > 0 ) {
				queryStr += "&idx=" + _idx
			}
			location.href = location.pathname + queryStr*/
			this.params = {
				mode: 'form',
				boardKey: this.defBoardKey,
			}

			if (_idx != null) {
				this.params.idx = _idx
			}

			this.pageUtils.routerPush(this, this.params)
			/*this.$router.push({
				query: this.params,
			}).catch(() => {})*/

			this.webUtils.scrollTo("#app-boards")

		},


	},
}
</script>

<style scoped>
.btn-submit {
	margin-bottom: 14px;
}
</style>
